import EngineeringIcon from '@mui/icons-material/Engineering';
import { Box, useTheme } from '@mui/material';
import bottomImage from './img/errorBottom.svg';
import topImage from './img/errorTop.svg';
import { SafeArea } from './SafeArea';

export const MaintenanceModeLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const theme = useTheme();

  return (
    <SafeArea
      edges={['top', 'bottom']}
      sx={{
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.primary.main,
        height: '100%',
        backgroundImage: `url("${topImage}")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top left',
        backgroundSize: '400px',
      }}
    >
      <Box
        sx={{
          height: '100%',
          backgroundImage: `url("${bottomImage}")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'bottom right',
          backgroundSize: '400px',
          padding: 2,
          color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.primary.contrastText,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <EngineeringIcon
          sx={{
            fontSize: '18vh',
            ml: {
              xs: '8%',
              sm: '6%',
              md: '4%',
            },
          }}
        />
        {children}
      </Box>
    </SafeArea>
  );
};
